import React from "react";
import { useNavigate } from "react-router-dom";

// Import child components and constants
import DescriptionSecondary from "./DescriptionSecondary";
import ContentOptions from "./ContentOptions";
import constants from "../../../utils/constants";
import { useGlobal } from "../../../context/GlobalContextProvider";

// FormBox Component
// Displays options for users to select a role (Sponsor or Artist) 
// and handles navigation to the corresponding paths.
export default function FormBox() {
  const { setCampaign, setArtPack, setMenuState } = useGlobal(); // Importing global context to manage state
  const navigate = useNavigate();  // Hook for navigating programmatically

  // Function to load Sponsor path and initialize related states
  const loadSponsor = () => {
    setCampaign(null)
    setArtPack(null)
    setMenuState(null)
    navigate(`${constants.SPONSOR_BASE_PATH}`); // Navigate to sponsor's base path
  };

  // Function to load Artist path and initialize related states
  const loadArtist = () => {
    setCampaign(null)
    setArtPack(null)
    setMenuState(null)
    navigate(`${constants.ARTIST_BASE_PATH}`); // Navigate to artist's base path
  };

  return (
    <>
      {/* Main container for selection options */}
      <div className="selection-card-row text-gray">

        {/* Sponsor selection option */}
        <ContentOptions
          description={
            <DescriptionSecondary text="Would you like to create and sponsor a Fund Raisin campaign?" />
          }
          handleName={loadSponsor}           // Handle click event for sponsor option
          valueButtom="Create a campaign"    // Button label
        />

        {/* Artist selection option */}
        <ContentOptions
          description={
            <DescriptionSecondary text="Would you like to create art packs that can then be used by Fund Raisin campaigns?" />
          }
          handleName={loadArtist}            // Handle click event for artist option
          valueButtom="Create art"           // Button label
        />
      </div>
    </>
  );
}
